import React from 'react';
import CommonService from '../../../../services/commonService';
import getIcons from '../../functions/getIcons/getIcons';

const ThemeEightHeader = ({ children, history, operator ,onMyAccountClick , loginData , t}) => {
  operator = operator || CommonService.getLocal('op') || {};

  return (
    operator && (
      <div className="themes-theme-eight-header">
        <style>
          .nav-section.home-nav-section.common-top-strip.header-box + * {'{'}
          margin-top:270px;
          {'}'}
          .nav-section.home-nav-section.common-top-strip.header-box.payments-page-header + * {'{'}
          margin-top:110px;
          {'}'}
        </style>
        <div
          style={{
            background:
              operator && operator.color_codes && operator.color_codes.primary_color
                ? operator.color_codes.primary_color
                : '',
            color: '#fff',
          }}
          className="nav"
        >
          <div className="new-container wrapper ">
            <div>
              <a
                href="/"
                style={{
                  color: '#fff',
                }}
              >
                <img
                  src={operator && operator.header_logo ? operator.header_logo : ''}
                  alt=""
                  className="logo2"
                  id="main-logo"
                  style={{
                    height: 'auto',
                    width: operator && operator.header_logo_width ? operator.header_logo_width : '',
                  }}
                />
              </a>
              <span className="logo-text less-bold-text">...Es viajar con agrado</span>
            </div>

            <div style={{ display: 'flex' }}>
              <div
                className="contact  pointer less-bold-text"
                style={{
                  color:
                    operator && operator.color_codes && operator.color_codes.primary_color
                      ? operator.color_codes.primary_color
                      : '',

                  marginRight: 10,
                  padding: '10px 14px',
                }}
                onClick={() => history.push('/privacy-policy')}
              >
                {/* <img src={getIcons('headphone')} alt="" /> */}
                <span>Políticas de privacidad</span>
              </div>
              <div
                className="contact  pointer less-bold-text"
                style={{
                  color:
                    operator && operator.color_codes && operator.color_codes.primary_color
                      ? operator.color_codes.primary_color
                      : '',
                }}
                onClick={() => history.push('/contact')}
              >
                <img src={getIcons('headphone')} alt="" />
                <span>Contacto</span>
              </div>
 
              {operator && operator.has_user_account && (
              <ul
                style={{ marginLeft: 20 }}
                // className="header-login-icon-container"
              >
                <li>
                  <div className="my-account-top font10">
                    <a onClick={onMyAccountClick}>
                      {CommonService.isLoggedIn(loginData) && loginData.image_link ? (
                        <div className="dp-image-top">
                          <img src={loginData.image_link} alt="DIS" />
                        </div>
                      ) : (
                        <div
                          className={
                            'menu-profile-icon-stripe circular-icon-stripe profile-circular-icon '
                          }
                        >
                          <img
                            src={getIcons('userIcon', operator)}
                            // src="/images/user_red_dot.svg"
                            alt={t('TRANSLATIONS.USER_DOT')}
                          />
                        </div>
                      )}
                      {/* {CommonService.isLoggedIn(this.props.common.loginData)
                          ? CommonService.capitalize(this.props.common.loginData.name)
                          : t('HOME.MY_ACCOUNT')} */}
                    </a>
                    {/* {this.state.showMyAccountDropDown ? this.renderMyAccountDropdown(t) : null} */}
                  </div>
                </li>
              </ul>
            )}
            
            </div>
          </div>
        </div>

        {children}
      </div>
    )
  );
};

export default ThemeEightHeader;



// WEBPACK FOOTER //
// ./src/features/themes/ThemeEight/common/ThemeEightHeader.js